"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var SharingAcceptButton_1 = require("../components/SharingAcceptButton");
function addInteractiveElementsForReadingPane(element, item) {
    var button = React.createElement(SharingAcceptButton_1.default, { item: item });
    ReactDOM.render(button, element, null /* callback */);
    element.className = ''; // overwrite the server's OLK-hidden class
}
exports.default = addInteractiveElementsForReadingPane;
//# sourceMappingURL=addInteractiveElementsForReadingPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/utils/addInteractiveElementsForReadingPane.js
// module id = 5802
// module chunks = 96